import React from "react";
import {
  LuCircleDollarSign,
  LuShoppingBag,
  LuTag,
  LuTrendingUp,
  LuPackage,
} from "react-icons/lu";
import KpiCard from "../../../shared/components/KpiCard/KpiCard";
import formatBRL from "../../../shared/utils/formatBRL";
import "./SalesKpiRow.css";

/**
 * Linha de indicadores da tela de Vendas. `kpis` vem de computeKpis()
 * (salesMetrics.js), já em reais.
 */
const SalesKpiRow = ({ kpis }) => {
  const number = (n) => n.toLocaleString("pt-BR");

  const cards = [
    {
      label: "Receita total",
      value: formatBRL(kpis.revenue),
      icon: LuCircleDollarSign,
      subtitle: "só pedidos pagos",
    },
    {
      label: "Pedidos",
      value: number(kpis.orders),
      icon: LuShoppingBag,
      subtitle: "pagos no período",
    },
    {
      label: "Ticket médio",
      value: formatBRL(kpis.averageTicket),
      icon: LuTag,
      subtitle: "receita ÷ pedidos pagos",
    },
    {
      label: "Lucro real",
      value: kpis.profit === null ? "—" : formatBRL(kpis.profit),
      icon: LuTrendingUp,
      subtitle: "pagos, itens com custo",
    },
    {
      label: "Itens vendidos",
      value: number(kpis.items),
      icon: LuPackage,
      subtitle: "unidades pagas",
    },
  ];

  return (
    <div className="sales-kpis">
      {cards.map((c) => (
        <KpiCard key={c.label} className="sales-kpi" {...c} />
      ))}
    </div>
  );
};

export default SalesKpiRow;
